import { useState } from 'react'
import axios from 'axios'
import { useCookies } from 'react-cookie'
import { api } from '../../common/api'
import { ACCESS_TOKEN } from 'src/common/util'

export type PlayerData = {
    childrenId: number
    childrenName: string
    childrenBirthDay: string
    childrenAcademyName: string
    childrenLevel: string
    childrenImageUrl: string
}

export default function useGetPlayers() {
    const baseUrl = api.base_url
    const [cookies] = useCookies([ACCESS_TOKEN])
    const [playerResults, setPlayerResults] = useState<PlayerData[]>([])
    const [filteredPlayerResults, setFilteredPlayerResults] = useState<PlayerData[]>([])
    const [playerError, setPlayerError] = useState('')

    const getPlayers = async (search: string): Promise<PlayerData[]> => {
        try {
          const response = await axios(`${baseUrl}/children/search?searchValue=${search}&page=0&size=20`, {
            method: 'GET',
            headers: {
                'Content-Type': 'application/json',
                'Authorization': `Bearer ${cookies[ACCESS_TOKEN]}`
            }
          })
          return response.data.data.content
        } catch (err) {
          console.error((err as Error).message)
          setPlayerError((err as Error).message)
          return []
        }
      }

    return { getPlayers, playerResults, setPlayerResults, filteredPlayerResults, setFilteredPlayerResults, playerError }
}